import React from "react";

const Dashboard: React.FC = () => (
    <main>

    </main>
);

export default Dashboard;
